export default __webpack_public_path__ + "static/media/tutorial-1.768cfe0c.svg";